
// Shared filename convention for every general digitization export format
// (task: "Filnavngivningen skal om muligt være fælles for PointViews
// generelle eksportformater og ikke være speciallogik kun for CSV") -
// GeoJSON/CSV/DXF/SHP all call this instead of each hardcoding its own
// "digitization_export.<ext>" (the previous, pre-this-task convention).
//
// Deliberately NOT used by DANVA XML export or any future specialised
// report (task: "Ændr ikke ukritisk specialiserede rapporter eller DANVA
// exchange-formater") - those keep whatever naming they already have/need.

// Point-cloud name resolution itself is NOT this module's job - see
// viewer.js's getPointcloudName(), which mirrors the already-established
// getProjection() convention (viewer.scene.pointclouds[0]) rather than
// inventing a separate "project name" concept. Callers pass the resolved
// name in; this module only turns (name, date) into a safe basename.

function pad2(n){
	return String(n).padStart(2, "0");
}

// One deterministic, filesystem-safe timestamp format - no colon (task:
// "Undgå eksempelvis kolon i klokkeslættet, da filnavnet skal fungere på
// Windows"), sortable, unambiguous.
export function formatExportTimestamp(date){
	return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}` +
		`_${pad2(date.getHours())}-${pad2(date.getMinutes())}-${pad2(date.getSeconds())}`;
}

// Windows reserves these ASCII characters in filenames (macOS/Linux are
// less restrictive, but the task explicitly calls out Windows
// compatibility) plus C0 control characters - nothing here touches
// non-ASCII/diacritic letters, so æ/ø/å/Æ/Ø/Å and any other Unicode letter
// pass through untouched (task: "Undgå unødvendig ASCII-translitterering
// af æ, ø og å").
const INVALID_FILENAME_CHARS = /[\\/:*?"<>|\x00-\x1f]/g;
const RESERVED_DEVICE_NAME = /^(CON|PRN|AUX|NUL|COM[1-9]|LPT[1-9])$/i;

export function sanitizeFilenamePart(name){
	let cleaned = String(name || "").replace(INVALID_FILENAME_CHARS, "_").trim();
	// Windows also disallows a name ending in a space or dot.
	cleaned = cleaned.replace(/[. ]+$/g, "");
	if(RESERVED_DEVICE_NAME.test(cleaned)) cleaned = `_${cleaned}`;
	return cleaned.length > 0 ? cleaned : "PointView";
}

export function buildExportBasename(pointcloudName, date = new Date()){
	return `${sanitizeFilenamePart(pointcloudName)}_${formatExportTimestamp(date)}`;
}

export function buildExportFilename(pointcloudName, extension, date = new Date()){
	return `${buildExportBasename(pointcloudName, date)}.${extension}`;
}
